import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    latitude:     Number,
    longitude:    Number,
    imageUrl:     String,
    venueName:    String,
    venueAddress: String,
    textColor:    String
  }

  connect() {
    this.coordinates = [this.latitudeValue, this.longitudeValue];
    this.map         = L.map(this.element).setView(this.coordinates, 15);
    this.marker      = L.marker(this.coordinates).addTo(this.map);

    this.marker.bindPopup(`
      <div style='display: flex; gap: 8px; align-items: center;'>
        <img
          src='${this.imageUrlValue}'
          alt='${this.venueNameValue}'
          style='width: 32px; height: 32px; object-fit: contain; border-radius: 4px; background-color: ${this.textColorValue};'
        />
        <div>
          <strong>${this.venueNameValue}</strong><br/>
          <span>${this.venueAddressValue}</span>
        </div>
      </div>
    `).openPopup();

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
  }
}
